import { useCallback, useState } from 'react';

const read = (key) => {
  try {
    return JSON.parse(localStorage.getItem(key)) || [];
  } catch {
    return [];
  }
};

export function useHiddenColumns(storageKey) {
  const [hidden, setHidden] = useState(() => read(storageKey));

  const save = useCallback(
    (next) => {
      setHidden(next);
      try {
        localStorage.setItem(storageKey, JSON.stringify(next));
      } catch {}
    },
    [storageKey]
  );

  const toggle = useCallback(
    (key) => save(hidden.includes(key) ? hidden.filter((k) => k !== key) : [...hidden, key]),
    [hidden, save]
  );

  return { hidden, toggle, reset: useCallback(() => save([]), [save]) };
}
